import { render } from "./DesProduct.vue?vue&type=template&id=712f0050&scoped=true"
import script from "./DesProduct.vue?vue&type=script&lang=js"
export * from "./DesProduct.vue?vue&type=script&lang=js"

import "./DesProduct.vue?vue&type=style&index=0&id=712f0050&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\iran\\iranrpm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712f0050"]])

export default __exports__